import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

import type { Note, SingleUserNoteResponse } from "./types";

type StoredToken = {
  AccessToken?: string;
};

export type UnpinUserNotePayload = {
  user_id: string;
  note_id: string;
};

// HTTP method note: the BE exposes pin/unpin as PATCH on the note resource
// (toggling the `is_pinned` attribute), not POST on a command sub-resource.
// This diverges from the typical REST convention of POST for action endpoints
// (AGENTS.md §7), but matches the published backend contract — do not change
// without coordinating with the backend team.
const unpinUserNote = async ({
  user_id,
  note_id,
}: UnpinUserNotePayload): Promise<Note | null> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.patch(
    API_ROUTES.UNPIN_USER_NOTE.replace("{user_id}", user_id).replace(
      "{note_id}",
      note_id,
    ),
  );

  const responseBody = response?.data as
    | Partial<SingleUserNoteResponse>
    | undefined;

  return (responseBody?.data as Note | undefined) ?? null;
};

export const useUnpinUserNote = () =>
  useMutation<Note | null, Error, UnpinUserNotePayload>({
    mutationKey: ["unpinUserNote"],
    mutationFn: unpinUserNote,
  });
